import { ajaxJson } from 'imports/ajax';
import { map2ChatObj, map2ForumUserObj } from 'imports/mapper';
import { chatActionsCreators } from 'db/chat/chat.action' 
import { ForumUserActionCreators } from 'db/user/user.action'
import { createTypes } from 'redux-create-types';


const namespace = 'chat-list';

export const chatListActions = createTypes([
    'toggleSpinner',
    'setError',
    'setChatList',
    'setCurrentPage',
    'setTotalPages',
    'setChatsCount',
    'activeAddMessageState',
    'setShowSearchReceiver',
    'setUsersList',
    'showSearchSpinner',
    'hideSearchSpinner',
    'setSelectedReceiver',
    'setMessageContent',
    'setMessageAttachment',
    'setMessageAttachmentName',
    'toggleShowEmojis',
    'hideEmojis',
    'removeMessageAttachment'
], namespace);




function hideEmojis() {
    return dispatch => {
        dispatch({
            type: chatListActions.toggleShowEmojis,
        })
    }
} 

function setMessageAttachmentName(payload) {
    return dispatch => {
        dispatch({
            type: chatListActions.setMessageAttachmentName,
            payload: payload
        })
    }
}

function removeMessageAttachment() {
    return dispatch => {
        dispatch({
            type: chatListActions.removeMessageAttachment
        })
    } 
}

function toggleShowEmojis(payload) {
    return dispatch => {
        dispatch({
            type: chatListActions.toggleShowEmojis,
            payload: payload
        })
    }
}

function setMessageAttachment(messageAttachment) {
    return dispatch => {
        dispatch({
            type: chatListActions.setMessageAttachment,
            payload: messageAttachment
        })
    }
}

function setMessageContent(messageContent) {
    return dispatch => {
        dispatch({
            type: chatListActions.setMessageContent,
            payload: messageContent
        })
    }
} 

function setSelectedReceiver(receiverData) {
    return dispatch => {
        dispatch({
            type: chatListActions.setSelectedReceiver,
            payload: receiverData
        })
    }
}

function showSearchSpinner() {
    return dispatch => {
        dispatch({
            type: chatListActions.showSearchSpinner,
            payload: true
        })
    }
}

function hideSearchSpinner() {
    return dispatch => {
        dispatch({
            type: chatListActions.hideSearchSpinner,
            payload: false
        })
    }
}

function showSpinner() {
    return dispatch => {
        dispatch({
            type: chatListActions.toggleSpinner,
            payload: true,
        });
    }
}


function setShowSearchReceiver(payload) {
    return dispatch => {
        dispatch({
            type: chatListActions.setShowSearchReceiver,
            payload: payload
        })
    }
}


function activeAddMessageState(addMessageState) {
    return dispatch => {
        dispatch({
            type: chatListActions.activeAddMessageState,
            payload: addMessageState
        })
    }
}


function setAddMessageState() {
    return dispatch => {
        dispatch({
            type: chatListActions.activeAddMessageState,
            payload: false
        })
    }
}


function setCurrentPage(currentPage) {
    return dispatch => {
        dispatch({
            type: chatListActions.setCurrentPage,
            payload: currentPage,
        })
    }
}


function setTotalPages(totalPages) {
    return dispatch => {
        dispatch({
            type: chatListActions.setTotalPages,
            payload: totalPages,
        })
    }
}


function setChatsCount(chatsCount) {
    return dispatch => {
        dispatch({
            type: chatListActions.setChatsCount,
            payload: chatsCount,
        })
    }
}


function hideSpinner() {
    return dispatch => {
        dispatch({
            type: chatListActions.toggleSpinner,
            payload: false,
        });
    }
}


function setChatList(chatIds) {
    return dispatch => {
        dispatch({
            type: chatListActions.setChatList,
            payload: chatIds
        })
    }
}


function setUsersList(userIds) {
    return dispatch => {
        dispatch({
            type: chatListActions.setUsersList,
            payload: userIds
        })
    }
}


function getChatsApiFail(err) {
    return dispatch => {
        dispatch({
            type: chatListActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner());
    }
}


function getChatsApiSuccess(res) {
    return dispatch => {
        res.data.results.forEach(chat => {
            const chatObj = map2ChatObj(chat);
            dispatch(chatActionsCreators.create(chatObj))
        });
        const chatIds = res.data.results.map(c => map2ChatObj(c).id);

        dispatch(setChatList(chatIds));
        dispatch(setTotalPages(res.data.total_pages)); 
        dispatch(setChatsCount(res.data.count));
        return dispatch(hideSpinner());
    }
}


function getChatsFromApi() {
    return (dispatch, getState) => {
        let state = getState()
        let currentPage = state.ui.chatListPage.currentPage
        dispatch(showSpinner())
        return ajaxJson.get('/chats', {params: {page: currentPage}})
            .then(
                res => dispatch(getChatsApiSuccess(res)),
                err => dispatch(getChatsApiFail(err))
            )
    }
}


function searchUsersApiSuccess(res) {
    return dispatch => {
        dispatch(hideSearchSpinner())
        res.data.staff.concat(res.data.classmates).forEach(user => {
            const userObj = map2ForumUserObj(user);
            dispatch(ForumUserActionCreators.create(userObj)) 
        });
        const userIds = res.data.staff.concat(res.data.classmates).map(c => map2ForumUserObj(c).id);
        dispatch(setUsersList(userIds));
    }
}


function searchUsersApiFail(err) {
    return dispatch => {
        dispatch(hideSearchSpinner())
        dispatch({
            type: chatListActions.setError,
            payload: err,
        })
    }
}


function searchUsersFromApi(queryText) {
    return dispatch => {
        dispatch(showSearchSpinner())
        return ajaxJson.get('/search/receivers', { params: { q: queryText } })
            .then(
                res => dispatch(searchUsersApiSuccess(res)),
                err => dispatch(searchUsersApiFail(err))
            )
    }
} 


function postChatMessageApiSuccess(res) {
    return dispatch => {
        dispatch(getChatsFromApi())
        dispatch(setAddMessageState())
        dispatch(removeMessageAttachment())
        dispatch(setSelectedReceiver(null))
        dispatch(setMessageContent(''))
    }
}


function postChatMessageApiFail(err) {
    return dispatch => {
        dispatch(hideSearchSpinner())
        dispatch({
            type: chatListActions.setError,
            payload: err,
        })
    }
}

function postChatMessageFromApi() {
    return (dispatch, getState) => {
        let state = getState()
        let formData = new FormData()
        formData.append('text', state.ui.chatListPage.messageContent)
        formData.append('receiver_uid', state.ui.chatListPage.selectedReceiver)
        if (state.ui.chatListPage.messageAttachment) {
            formData.append('file', state.ui.chatListPage.messageAttachment)
        }
        return ajaxJson.post('/chats/chat-messages', formData)
            .then(
                res => dispatch(postChatMessageApiSuccess(res)),
                err => dispatch(postChatMessageApiFail(err))
            )
    }
}


export const chatListActionCreators = {
    getChatsFromApi,
    setCurrentPage,
    activeAddMessageState,
    setShowSearchReceiver,
    searchUsersFromApi,
    setSelectedReceiver,
    setMessageContent,
    postChatMessageFromApi,
    setMessageAttachment,
    toggleShowEmojis,
    hideEmojis,
    removeMessageAttachment,
    setMessageAttachmentName
} 
